var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:('position: relative; height: ' + _vm.height + 'px; overflow: hidden')},[_c('div',{style:('position: relative; top: -8px; width: calc(100% + 20px); height: ' + (_vm.height + 18)
            + 'px; left: -12px')},[_c('apexchart',{attrs:{"type":"area","height":(_vm.height + 18),"options":_vm.chart_options,"series":_vm.series}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }